import script from "./attachment-list-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./attachment-list-item.vue?vue&type=script&setup=true&lang=ts"

import "./attachment-list-item.vue?vue&type=style&index=0&id=f9b55366&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9b55366"]])

export default __exports__